import React, { useEffect, useMemo, useState } from "react";
import BreadCrumb from "../components/BreadCrumb";
import Meta from "../components/Meta";
import ReactStars from "react-rating-stars-component";
import ProductCard from "../components/ProductCard";
import Color from "../components/Color";
import Container from "../components/Container";
import { useDispatch, useSelector } from "react-redux";
import { getAllCategory, getAllProducts, getAllProductsStore } from "../features/products/productSlilce";
import { Link, useLocation, useParams } from "react-router-dom";
import DataNotFound from "../components/DataNotFound";
import { useSearchParams } from "react-router-dom";


const categorySEOMap = {
  "women-clothing": {
    title: "Women Clothing Online in India | Shoplintic",
    description:
      "Buy women clothing online in India at Shoplintic. Winter wear, socks, leggings & fashion essentials at best prices.",
  },
  "winter-wear": {
    title: "Winter Wear for Men & Women | Shoplintic",
    description:
      "Shop winter wear online in India. Thermal wear, socks & warm clothing at best prices.",
  },
  "cosmetics": {
    title: "Buy Cosmetics Online in India | Shoplintic",
    description:
      "Buy cosmetics online in India. Makeup & beauty products at best prices.",
  },
  "accessories": {
    title: "Fashion & Home Accessories Online | Shoplintic",
    description:
      "Shop accessories online at Shoplintic. Trending fashion & lifestyle accessories.",
  },
};





const OurStore = ({ fetchCart, fetchWishlist }) => {
 const [grid, setGrid] = useState(3);
const rawProductData = useSelector((state) => state?.product?.product);
const productState = Array.isArray(rawProductData)
  ? rawProductData.flatMap((item) =>
      Array.isArray(item?.products) ? item.products : []
    )
  : Array.isArray(rawProductData?.products)
  ? rawProductData.products
  : [];
  const productCategory = useSelector((state) =>
    state?.product?.category?.map((item) => item)
  ) || [];
  const [brands, setBrands] = useState([]);
  const [categories, setCategories] = useState([]);
  const [tags, setTags] = useState([]);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const cat = queryParams.get("category");
  const slug = queryParams.get("slug");
  const brandName = queryParams.get("brand");
  const tagName = queryParams.get("tag");
  const [tag, setTag] = useState(tagName || null);
  const [category, setCategory] = useState(cat || null);
  const [brand, setBrand] = useState(null);
  const [minPrice, setminPrice] = useState(null);
  const [maxPrice, setmaxPrice] = useState(null);
  const [sort, setSort] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchParams] = useSearchParams();
  // const [filteredProducts, setFilteredProducts] = useState([]);
  const itemsPerPage = 12;
  const dispatch = useDispatch();


const filteredProducts = useMemo(() => {
  const searchQuery =
    searchParams.get("search")?.replace(/\+/g, " ") || "";

  if (!searchQuery || !Array.isArray(productState)) return [];

  const normalizedSearch = normalize(searchQuery);

  return productState.filter((product) => {
    return (
      fuzzyMatch(normalizedSearch, normalize(product.name)) ||
      fuzzyMatch(normalizedSearch, normalize(product.isbn?.toString())) ||
      fuzzyMatch(normalizedSearch, normalize(product.category)) ||
      fuzzyMatch(normalizedSearch, normalize(product.tags)) ||
      fuzzyMatch(normalizedSearch, normalize(product.description))
    );
  });
}, [
  productState,
  searchParams.get("search"), // ✅ STABLE dependency
]);



  const activeCategorySlug = category || cat || "product";

  const seoData =
    categorySEOMap[activeCategorySlug] || {
      title: "Online Shopping Store | Shoplintic",
      description:
        "Shop fashion, clothing, cosmetics & accessories online at Shoplintic.",
    };

  const canonicalUrl = `https://www.shoplintic.in/product${
    activeCategorySlug ? `?category=${activeCategorySlug}` : ""
  }`;






  const normalize = (str) =>
    str?.toLowerCase().replace(/[_-]/g, " ").replace(/\s+/g, " ").trim() || "";

  const fuzzyMatch = (input, target) => {
    if (!input || !target) return false;
    let i = 0, j = 0;
    while (i < input.length && j < target.length) {
      if (input[i] === target[j]) i++;
      j++;
    }
    return i === input.length;
  };

  const paginatedOrders =
    filteredProducts && filteredProducts.length > 0
      ? [...filteredProducts].reverse().slice(
          (currentPage - 1) * itemsPerPage,
          currentPage * itemsPerPage
        )
      : productState && productState.length > 0
      ? [...productState].reverse().slice(
          (currentPage - 1) * itemsPerPage,
          currentPage * itemsPerPage
        )
      : [];

  const totalPages =
    filteredProducts && filteredProducts.length > 0
      ? Math.ceil(filteredProducts.length / itemsPerPage)
      : productState && productState.length > 0
      ? Math.ceil(productState.length / itemsPerPage)
      : 0;

useEffect(() => {
  let newBrands = brandName ? [brandName] : [];
  let categoryList = cat ? [cat] : [];
  let newTags = tagName ? [tagName] : [];

  productState.forEach((element) => {
    if (element?.brand) newBrands.push(element.brand);
    if (element?.category) categoryList.push(element.category);
    if (element?.tags) newTags.push(element.tags);
  });

  // Compare before setting to avoid unnecessary updates
  if (JSON.stringify(newBrands) !== JSON.stringify(brands)) {
    setBrands(newBrands);
  }
  if (JSON.stringify(categoryList) !== JSON.stringify(categories)) {
    setCategories(categoryList);
  }
  if (JSON.stringify(newTags) !== JSON.stringify(tags)) {
    setTags(newTags);
  }
  if (tag !== (tagName || null)) {
    setTag(tagName || null);
  }

}, [productState, brandName, cat, tagName]); 

useEffect(() => {
  getProducts();
  dispatch(getAllCategory());
}, [
  sort,
  tag,
  brand,
  category, // ✅ REQUIRED
  minPrice,
  maxPrice,
  tagName,
  cat,
  brandName,
  searchParams,
]);


  const getProducts = () => {
   dispatch(
  getAllProductsStore({
    sort,
    tag,
    brand: brand || brandName,
    category_slug: category || cat, // ✅ dynamic state
    minPrice,
    maxPrice,
  })
);

  };


  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const tagsList = [
    { id: 1, value: "now_trending", name: "Now Trending" },
    { id: 2, value: "best_seller", name: "Best Seller" },
    { id: 3, value: "new_arrival", name: "New Arrival" },
    // { id: 4, value: "intl_bs", name: "International Best Seller" },
    // { id: 5, value: "award_winner", name: "Award Winner" },
    // { id: 6, value: "bw_top_sellers", name: "BW Top Books" },
  ];

  return (
    <>
   <Meta
  title={seoData.title}
  description={seoData.description}
  canonical={canonicalUrl}
/>

<BreadCrumb
  title={seoData.title.replace(" | Shoplintic", "")}
/>
   <Container class1="store-wrapper home-wrapper-2 py-5" >
  <div className="row">
    {/* Sidebar */}
    
{/* Mobile Filter Accordion */}
<div className="col-12 d-md-none mb-4">
  <div className="accordion" id="mobileFilterAccordion">
    
    {/* Categories */}
    <div className="accordion-item">
      <h2 className="accordion-header" id="headingCategory">
        <button
          className="accordion-button collapsed"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#collapseCategory"
        >
          Shop By Categories
        </button>
      </h2>
      <div
        id="collapseCategory"
        className="accordion-collapse collapse"
        data-bs-parent="#mobileFilterAccordion"
      >
        <div className="accordion-body">
          <ul className="ps-0 list-unstyled">
            <li>
              <a href="/product" style={{ color: "var(--color-777777)" }}>
                All
              </a>
            </li>
            {productCategory &&
              [...new Set(productCategory)].map((item, index) => (
             <li
  key={index}
  className="cursor-pointer"
  onClick={() => {
    setCurrentPage(1);
    setCategory(item?.unique_slug);
  }}
>
  {item?.title}
</li>
              ))}
          </ul>
        </div>
      </div>
    </div>

    {/* Tags */}
    <div className="accordion-item">
      <h2 className="accordion-header" id="headingTags">
        <button
          className="accordion-button collapsed"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#collapseTags"
        >
          Product Tags
        </button>
      </h2>
      <div
        id="collapseTags"
        className="accordion-collapse collapse"
        data-bs-parent="#mobileFilterAccordion"
      >
        <div className="accordion-body d-flex flex-wrap gap-2">
          {tagsList &&
            [...new Set(tagsList)].map((item, index) => (
              <span
                key={index}
                onClick={() => setTag(item.value)}
                className="badge bg-light text-secondary rounded-3 py-2 px-3 cursor-pointer"
              >
                {item?.name}
              </span>
            ))}
        </div>
      </div>
    </div>

    {/* Brands */}
    <div className="accordion-item">
      <h2 className="accordion-header" id="headingBrands">
        <button
          className="accordion-button collapsed"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#collapseBrands"
        >
          Product Brands
        </button>
      </h2>
      <div
        id="collapseBrands"
        className="accordion-collapse collapse"
        data-bs-parent="#mobileFilterAccordion"
      >
        <div className="accordion-body d-flex flex-wrap gap-2">
          {brands &&
            [...new Set(brands)].map((item, index) => (
              <span
                key={index}
                onClick={() => setBrand(item)}
                className="badge bg-light text-secondary rounded-3 py-2 px-3 cursor-pointer"
              >
                {item}
              </span>
            ))}
        </div>
      </div>
    </div>

    {/* Price */}
    <div className="accordion-item">
      <h2 className="accordion-header" id="headingPrice">
        <button
          className="accordion-button collapsed"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#collapsePrice"
        >
          Filter By Price
        </button>
      </h2>
      <div
        id="collapsePrice"
        className="accordion-collapse collapse"
        data-bs-parent="#mobileFilterAccordion"
      >
        <div className="accordion-body">
          <div className="d-flex flex-column gap-10">
            <div className="form-floating mb-2">
              <input
                type="number"
                className="form-control"
                id="priceFromMobile"
                placeholder="From"
                onChange={(e) => setminPrice(e.target.value)}
              />
              <label htmlFor="priceFromMobile">From</label>
            </div>
            <div className="form-floating">
              <input
                type="number"
                className="form-control"
                id="priceToMobile"
                placeholder="To"
                onChange={(e) => setmaxPrice(e.target.value)}
              />
              <label htmlFor="priceToMobile">To</label>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>

    <div className="col-12 col-md-4 col-lg-3 mb-4 hide-on-mobile-view" >
      <div className="filter-card mb-3">
        <h3 className="filter-title">Shop By Categories</h3>
        <div>
          <ul className="ps-0">
            <a
              className="ps-0"
              href="/product"
              style={{ color: "var(--color-777777)" }}
            >
              All
            </a>
            {productCategory &&
              [...new Set(productCategory)].map((item, index) => (
                <li key={index} onClick={() => setCategory(item?.unique_slug)}>
                  {item?.title}
                </li>
              ))}
          </ul>
        </div>
      </div>

      <div className="filter-card mb-3">
        <h3 className="filter-title">Filter By</h3>
        <div>
          <h5 className="sub-title">Price</h5>
          <div className="d-flex flex-column flex-sm-row align-items-start align-items-sm-center gap-10">
            <div className="form-floating w-100">
              <input
                type="number"
                className="form-control"
                id="floatingInput"
                placeholder="From"
                onChange={(e) => setminPrice(e.target.value)}
              />
              <label htmlFor="floatingInput">From</label>
            </div>
            <div className="form-floating w-100">
              <input
                type="number"
                className="form-control"
                id="floatingInput1"
                placeholder="To"
                onChange={(e) => setmaxPrice(e.target.value)}
              />
              <label htmlFor="floatingInput1">To</label>
            </div>
          </div>
        </div>

        {/* Product Tags */}
        <div className="mt-4 mb-3">
          <h3 className="sub-title">Product Tags</h3>
          <div className="product-tags d-flex flex-wrap align-items-center gap-10">
            {tagsList &&
              [...new Set(tagsList)].map((item, index) => (
                <span
                  key={index}
                  onClick={() => setTag(item.value)}
                  className="text-capitalize badge bg-light text-secondary rounded-3 py-2 px-3 cursor-pointer"
                >
                  {item?.name}
                </span>
              ))}
          </div>
        </div>

        {/* Product Brands */}
        <div className="mt-4 mb-3">
          <h3 className="sub-title">Product Brands</h3>
          <div className="product-tags d-flex flex-wrap align-items-center gap-10">
            {brands &&
              [...new Set(brands)].map((item, index) => (
                <span
                  key={index}
                  onClick={() => setBrand(item)}
                  className="text-capitalize badge bg-light text-secondary rounded-3 py-2 px-3 cursor-pointer"
                >
                  {item}
                </span>
              ))}
          </div>
        </div>
      </div>
    </div>

    {/* Main Content */}
    <div className="col-12 col-md-8 col-lg-9">
      <h1 className="visually-hidden">
  {seoData.title.replace(" | Shoplintic", "")}
</h1>
      <div className="filter-sort-grid mb-4">
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3">
          {/* Sort */}
          <div className="d-flex align-items-center gap-10 md-w-50 w-100">
            <p className="mb-0 d-block" style={{ width: "100px" }}>
              Sort By:
            </p>
            <select
              name=""
              defaultValue={"manual"}
              className="form-control form-select md-w-50 w-100"
              id=""
              onChange={(e) => setSort(e.target.value)}
            >
              <option value="title">Alphabetically, A-Z</option>
              <option value="-title">Alphabetically, Z-A</option>
              <option value="price">Price, low to high</option>
              <option value="-price">Price, high to low</option>
              <option value="createdAt">Date, old to new</option>
              <option value="-createdAt">Date, new to old</option>
            </select>
          </div>

          {/* Grid View Selector */}
          <div className="d-flex align-items-center gap-10">
            <p className="totalproducts mb-0">
              {productState?.length} Products
            </p>
            <div className="d-none d-md-flex gap-10 align-items-center grid hide-on-mobile-view">
              <img
                onClick={() => setGrid(3)}
                src="images/gr4.svg"
                className="d-block img-fluid"
                alt="grid"
              />
              <img
                onClick={() => setGrid(4)}
                src="images/gr3.svg"
                className="d-block img-fluid"
                alt="grid"
              />
              <img
                onClick={() => setGrid(6)}
                src="images/gr2.svg"
                className="d-block img-fluid"
                alt="grid"
              />
              <img
                onClick={() => setGrid(12)}
                src="images/gr.svg"
                className="d-block img-fluid"
                alt="grid"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Product List */}
    {paginatedOrders?.length>0 ?  <div className="products-list pb-5">
        <div className="d-flex gap-10 flex-wrap">
          <ProductCard data={paginatedOrders ? paginatedOrders : []} grid={grid} fetchCart={fetchCart} fetchWishlist={fetchWishlist} />
        </div>

        {/* Pagination */}
        {totalPages > 1 && (
          <div className="d-flex justify-content-center mt-4">
            <nav>
              <ul className="pagination">
                {[...Array(totalPages)].map((_, i) => (
                  <li
                    key={i}
                    className={`page-item ${
                      currentPage === i + 1 ? "active" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => setCurrentPage(i + 1)}
                    >
                      {i + 1}
                    </button>
                  </li>
                ))}
              </ul>
            </nav>
          </div>
        )}
      </div> :
      <DataNotFound />
      }
    </div>
  </div>
</Container>

    </>
  );
};

export default OurStore;
